<template>
  <div class='row-libray'>
    <LeftListMember :pos="5"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1 m-libray">
        <!-- <div class="top">
          <div class="tit">按供应商名称查询：</div>
          <a-input-search class="m-so" placeholder="请输入供应商名称" v-model="search.supplier" @search="onSearch" />
        </div> -->
        <div class="m-searchnew">
          <div class="form">
            <div class="left-tit">按条件查询：</div>
            <div class="right-inp">
              <div class="inp">
                <el-input v-model="search.isbn" type="text" name="" id="" placeholder="请输入标准书号" />
              </div>
              <div class="inp">
                <el-input v-model="search.name" type="text" name="" id="" placeholder="请输入书名" />
              </div>
              <div class="inp">
                <el-input v-model="search.publisher" type="text" name="" id="" placeholder="请输入出版社名称" />
              </div>
              <div class="inp">
                <el-input v-model="search.author" type="text" name="" id="" placeholder="请输入作者名称" />
              </div>
              <div class="inp">
                <el-input v-model="search.supplier" type="text" name="" id="" placeholder="请输入供应商名称" />
              </div>
            </div>
            <button class="btn" @click="load(1)"><img src="@/assets/images/index/icon6.png" class="icon" alt="" style="max-height: 60%;" /></button>
          </div>
        </div>

        <div class="contect g-contecte1">
          <div class="top1">
            <div class="tit2">收藏列表</div>
            <div class="con2">
<!--              <div class="btn1" @click="showModal">导入目录</div>-->
              <div class="btn1 btn2" @click="batchDel">批量删除</div>
            </div>
          </div>

          <div class="m-table m-table-collection">

            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id" :columns="columns"
              :data-source="data" :pagination="false" :bordered="false" >
              <div slot="delete" slot-scope="index, record, indent, expanded" class="delete" style="color: #188EFC;" :scroll="{ x: 700 }">
                <span class="" @click="addCart(record)">{{record.isCart ? '移除订单' : '添加订单'}}</span>
                <span @click="del(record.id)">删除</span>
              </div>
              <div slot="publishDate"><span class="td1 on" :class="{ active1: isOrderPublishDateOn }"
                  @click="toggleActive1">出版日期<img src="@/assets/images/e-load2.png" class="icon" alt="" /><img
                    src="@/assets/images/e-load2-on.png" class="icon icon2" alt="" /></span></div>

              <div slot="supplier" slot-scope="supplier, record, indent, expanded">
                <a @click="openSupplier(record.book.uid)" class="supplier" >{{ record.book.supplier }}</a>
              </div>
              <div slot="fixprice"><span class="td1" :class="{ active2: isOrderPriceOn }" @click="toggleActive2">定价<img
                    src="@/assets/images/e-load1.png" class="icon" alt="" /><img src="@/assets/images/e-load1-on.png"
                    class="icon icon2" alt="" /></span></div>
              <div slot="discount"><span class="td1 td2 " :class="{ active: isOrderDiscountOn }" @click="toggleActive">折扣<img
                    src="@/assets/images/e-icon4.png" class="icon" alt="" /><img src="@/assets/images/e-icon4-on.png"
                    class="icon icon2" alt="" /></span></div>
              <!-- <div slot="discount" slot-scope="index, record, indent, expanded" class="discount"
                style="color: #3871E9;">
                <span>折扣</span>
              </div> -->
            </a-table>
          </div>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import mPages from '@/components/mpages/mPages.vue'
import LeftListMember from "@/components/LeftListMember.vue";
import {getApiRes} from "@/api/apiUtil";
import apiBkBook from "@/api/bkBook";
import apiBkBookFavor from "@/api/bkBookFavor";
import apiUserInfo from "@/api/userInfo";
import apiBkBookCart from "@/api/bkBookCart";
export default {
  components: {
    LeftListMember,
    mPages,
  },
  data() {
    return {
      //
      isOrderPublishDateOn: false,
      isOrderPriceOn: false,
      isOrderDiscountOn: false,
      //
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,

      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        name2: '',
        name3: '',
        name4: '',
        region: undefined,
        region2: undefined,
      },
      // 表格
      selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "ISBN",
          dataIndex: "book.isbn",
          key: "book.isbn",
          width: '9.5%',
        },
        {
          title: "书名",
          dataIndex: "book.name",
          key: "book.name",
          width: '30%',
          ellipsis: true,
        },
        {
          title: "出版社",
          dataIndex: "book.publisher",
          key: "book.publisher",
          width: '9.5%',
          ellipsis: true,
        },
        {
          title: "作者",
          dataIndex: "book.author",
          key: "book.author",
          ellipsis: true,
          width: '4.7%',
        },

        {
          title: "发行时间",
          dataIndex: "book.publishDate",
          key: "book.publishDate",
          ellipsis: true,
          width: '7.4%',
          slots: { title: 'publishDate' },
          scopedSlots: { customRender: '发行时间' },
        },

        // {
        //   title: "印刷日期",
        //   dataIndex: "book.printDate",
        //   key: "book.printDate",
        //   ellipsis: true,
        //   width: '6.8%',
        // },
        {
          title: "开本",
          dataIndex: "book.pageSize",
          key: "book.pageSize",
          ellipsis: true,
          width: '3.3%',
        },
        {
          // title: "定价",
          dataIndex: "book.price",
          key: "book.price",
          ellipsis: true,
          width: '6.1%',
          // sorter: true,
          // scopedSlots: { customRender: 'name' },
          slots: { title: 'fixprice' },
          scopedSlots: { customRender: '定价' },
        },
        {
          // title: "折扣",
          dataIndex: "book.discount",
          key: "book.discount",
          ellipsis: true,
          width: '6.1%',
          slots: { title: 'discount' },
          scopedSlots: { customRender: '折扣' },
        },

        {
          title: "供应商",
          dataIndex: "book.supplier",
          key: "book.supplier",
          ellipsis: true,
          width: '12.8%',
          scopedSlots: { customRender: 'supplier' },
        },
        {
          title: "操作",
          dataIndex: "operate",
          key: "operate",
          ellipsis: true,
          width: '12.8%',
          scopedSlots: { customRender: 'delete' },
        },

      ],

      data: [],
      dataCount: 0,
      search: {
        isbn: '',
        name: '',
        publisher: '',
        author: '',
        supplier: ''
      },
      filter: {
        isBook: true,
        page: 1,
        pageSize: 20,
        order: undefined
      },
    };
  },
  computed: {},
  watch: {
    filter:{
      handler() {
        this.load()
      },
      deep: true
    },
    isOrderDiscountOn(){
      this.getOrder('discount')
    },
    isOrderPriceOn(){
      this.getOrder('price')
    },
    isOrderPublishDateOn(){
      this.getOrder('publishDate')
    }
  },
  mounted() {
    this.load(1)

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }
  },
  methods: {
    getOrder(orderBy){
      let orders = []
      orders.push('publishDate '+ (this.isOrderPublishDateOn ? 'asc' : 'desc'))
      orders.push('price ' + (this.isOrderPriceOn ? 'asc' : 'desc'))
      orders.push('discount ' + (this.isOrderDiscountOn ? 'asc' : 'desc'))
      orders.sort((a,b)=>a.indexOf(orderBy)>-1?-1:1) //按参数字段排在前面
      this.filter.order = orders.join(',')
    },
    async load(page=undefined){
      if(page) this.filter.page = page
      let map = []
      if(this.search.isbn) map.push(['isbn','like',`%${this.search.isbn}%`])
      if(this.search.name) map.push(['name','like',`%${this.search.name}%`])
      if(this.search.publisher) map.push(['publisher','like',`%${this.search.publisher}%`])
      if(this.search.author) map.push(['author','like',`%${this.search.author}%`])
      if(this.search.supplier) map.push(['supplier','like',`%${this.search.supplier}%`])
      let re = await getApiRes(apiBkBookFavor.getList(undefined,undefined,map,'',[],this.filter), 0, 1,1)
      this.data = re.data
      this.dataCount = re.count
    },
    async addCart(item){
      let fun = item.isCart ? apiBkBookCart.remove : apiBkBookCart.add
      let re = await getApiRes(fun(item.book.id),0,1,1,1)
      if(re.code==0){
        item.isCart = !item.isCart
      }
    },
    async del(id){
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBookFavor.listDel(id),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async batchDel(){
      if(this.selectedRowKeys.length==0) return this.$message.error('请选择要删除的数据')
      let reConfirm = await this.$confirm('确定要删除吗?').catch((e)=>false)
      if(!reConfirm) return
      let re = await getApiRes(apiBkBookFavor.listDel(this.selectedRowKeys),0,1,1,1)
      if(re.code==0){
        this.load()
      }
    },
    async openSupplier(uid){
      let re = await getApiRes(apiUserInfo.GetShowIdByUid(uid),0,1,1,0)
      if(re.code==0 && re.data){
        window.open('/home/user_info/home?id='+re.data, '_blank')
      }
    },
    // 类名
    toggleActive1() {
      this.isOrderPublishDateOn = !this.isOrderPublishDateOn;
    },
    toggleActive2() {
      this.isOrderPriceOn = !this.isOrderPriceOn;
    },
    toggleActive() {
      this.isOrderDiscountOn = !this.isOrderDiscountOn;
    },
    // 类名end
    showModal() {
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
    // 表格
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },

  },
};

</script>

<style lang="scss" scoped>
.ant-input-affix-wrapper .ant-input-suffix {
  right: 0;
}
</style>
